import React from 'react';
import { Divider, Grid, Typography } from "@mui/material";
import CardPrestation from './cards/CardPrestation';
import ServicePrestation from '../services/ServicePrestation';

export default function ListePrestations() {

	// Chargement de la liste des prestations
	const prestations = ServicePrestation.getPrestations();

	return (
		<Grid item py={2} px={{ xs: 0, sm: 2, md: 4, lg: 20 }}>
			<Typography component="h1" sx={{ color: '#004afe', fontSize: { xs: 26, sm: 36, md: 36, lg: 54 }, fontWeight: 600 }}>
				Liste des prestations
			</Typography>
			<Divider sx={{ backgroundColor: '#004afe', mb: 4, mt: 2, height: 3, width: 130 }} />

			<Grid container /** sx={{ display: 'flex', justifyContent: 'center' }}*/>
				{
					// Boucle sur la liste des prestations
					prestations.map(function(d) {

						return (

							// Si la prestation est active
							d.active && (

								<Grid key={d.key} item xs={12} sm={6} md={4} sx={{ px: 2, pb: 2 }}>
									<CardPrestation prestation={d} />
								</Grid>
							)
						)
					})
				}
			</Grid>
		</Grid>
	);
}